<script>
import BaseEditOrder from './Edit.vue'
import LineItems from './CreateSubOrder/LineItems.vue'
export default {
  extends: BaseEditOrder,
  components: {
    LineItems
  },
  computed: {
    title() {
      return 'Add Sub Order'
    },
    action() {
      return 'sub-order'
    },
    submitUri() {
      return `sub-order/create/${this.orderId}`
    },
    editable() {
      return {
        order: true,
        quantity: true
      }
    }
  },
  mounted() {
    this.$emitter.on('Modal.Order.CreateSubOrder.EditLineItem.Submit', this.actionEditSubOrderLineItemSubmit)
  },
  unmounted() {
    this.$emitter.off('Modal.Order.CreateSubOrder.EditLineItem.Submit', this.actionEditSubOrderLineItemSubmit)
  },
  methods: {
    actionEditSubOrderLineItemSubmit(data) {
      let newLineItem = Object.assign({}, data)
      if (this.data?.line_items?.[newLineItem?.index]) {
        this.data.line_items[newLineItem.index] = Object.assign({}, this.data.line_items[newLineItem.index], newLineItem)
      }
    }
  },
  props: {
    config: Object
  }
}
</script>
